import React from "react";
import { Trans } from "@lingui/react/macro";
import { GOOGLE_MAPS_API_KEY } from "../../constants";

const ProjectDetails = ({ project, translatedDescription, translatedDetailedDescription, currentLocation }) => {
    return (
        <div className="project-details">
            <div className="project-info">
                {/* 30/10/2026 (Bartel): verzekeringsdossier (RAMI/Jaimy/IMA) waarvan het mandaat nog niet getekend is.
                    De vlag komt van de administratie (mandaat_te_tekenen) en gaat uit zodra het getekende exemplaar
                    in Dropbox staat. Bovenaan, vóór alles wat de werker alleen maar leest. */}
                {project.mandaat_te_tekenen ? (
                    <div className="mandate-warning" role="alert">
                        <span className="mandate-warning-icon" aria-hidden="true">✍</span>
                        <Trans>Insurance project: have the customer sign the mandate before you leave.</Trans>
                    </div>
                ) : null}
                <h1><Trans>Project Details</Trans></h1>
                <p><strong><Trans>Customer:</Trans></strong> {project.customer_name}</p>
                <p><strong><Trans>Description:</Trans></strong> {translatedDescription}</p>
                <p><strong><Trans>Detailed Description:</Trans></strong> {translatedDetailedDescription}</p>
                <p><strong><Trans>Residence:</Trans></strong> {project.residence_name}</p>
                <p><strong><Trans>Address:</Trans></strong> {project.street}, {project.house_number}, {project.postal_number} {project.town}</p>

                {project.workers && project.workers.length > 0 ? (
                    <div>
                        <p><strong><Trans>Together with:</Trans></strong></p>
                        <ul>
                            {project.workers.map((worker, index) => (
                                <li key={index}>
                                    {worker.first_name || worker.last_name
                                        ? `${worker.first_name || ''} ${worker.last_name || ''}`.trim()
                                        : worker.username}
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <p><strong><Trans>This project is done alone</Trans></strong></p>
                )}
            </div>

            <div className="project-map">
                <iframe
                    title="Google Maps"
                    className="google-map"
                    src={`https://www.google.com/maps/embed/v1/directions?key=${GOOGLE_MAPS_API_KEY}&origin=${currentLocation}&destination=${encodeURIComponent(
                        `${project.street} ${project.house_number}, ${project.postal_number} ${project.town}`
                    )}&mode=driving`}
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    );
};

export default ProjectDetails;